<template>
  <b-card header="Reporte pago de variables">
    <b-row class="form-group">
      <b-col cols="12">
        <b-form @submit.prevent="send()">
          <b-row class="form-group">
            <label for="" class="col-sm-2 col-form-label">Empresa de transporte</label>
            <div class="col-sm-3">
              <v-select
                placeholder="Todos"
                v-model="provider"
                :disabled="external == 0"
                :options="providers"
                :clearable="EnabledProvider"
                label="name"
                :on-change="setProvider">
              </v-select>
            </div>
          </b-row>
          <!-- <b-row v-if="this.provider" class="form-group">
            <label class="col-sm-2 col-form-label"></label>
            <div v-if="user.role.code !== constants.PROVEEDOR"
                 class="col-sm-5 col-form-label alert alert-info"
                 role="alert">
              Si requiere liquidar, darle clic en [X] para seleccionar todos
            </div>
          </b-row> -->
          <b-row class="form-group">
            <label class="col-sm-2 col-form-label"></label>
            <div v-if="user.role.code !== constants.PROVEEDOR" class="col-sm-5">
              <input type="radio" v-model="external" :value="false" @click="reset()"> Flota propia<br>
              <input type="radio" v-model="external" :value="true" @click="reset()"> Terceros y/o alquilados<br>
            </div>
          </b-row>
          <b-row v-if="external === true" class="form-group">
            <label class="col-sm-2 col-form-label">Arrumaje - Descuento de Terceros:</label>
            <div class="col-sm-1">
              <input :disabled="EnabledDiscountProvider" type="text" class="form-control"
                     v-model="arr_discount_third">
            </div>
          </b-row>
          <b-row v-if="external === true" class="form-group">
            <label class="col-sm-2 col-form-label">Arrumaje - Descuento de Alquilados:</label>
            <div class="col-sm-1">
              <input :disabled="EnabledDiscountProvider" type="text" class="form-control"
                     v-model="arr_discount_rented">
            </div>
          </b-row>

          <b-row class="form-group">
            <label class="col-sm-2 col-form-label">Desde</label>
            <div class="col-sm-3">
              <date-picker
                v-model="start_date"
                lang="es"
                type="date"
                format="DD/MM/YYYY"
              ></date-picker>
            </div>
          </b-row>
          <b-row class="form-group">
            <label class="col-sm-2 col-form-label">Hasta</label>
            <div class="col-sm-3">
              <date-picker
                v-model="end_date"
                lang="es"
                type="date"
                format="DD/MM/YYYY"
              ></date-picker>
            </div>
          </b-row>
          <b-row>
            <div class="offset-sm-2 col-sm-7">
              <input type="submit" class="btn btn-primary" value="Buscar">
            </div>
          </b-row>
        </b-form>
      </b-col>
    </b-row>

    <b-row v-if="loading">
      <b-col cols="12">
        <div class="fa-2x center">
          <span class="fa fa-spinner fa-spin"></span>
        </div>
      </b-col>
    </b-row>

    <b-row class="form-group" v-if="filteredPayments.length && !loading">
      <b-col cols="12">

        <div class="form-group form-inline pull-left">
          <!-- <select v-model="numPages" class="form-control">
            <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
          </select> &nbsp;
          <input v-model="search" type="search" class="form-control" placeholder="Buscar" /> &nbsp; -->
        </div>
        <div class="form-group form-inline pull-right">
          <download-excel
            class="btn btn-primary"
            :data="payments"
            :fields="json_fields"
            name="Tarifa_por_servicio.xls"
          >Descargar Excel
          </download-excel>&nbsp;
          <button @click="addPayments(false)" class="btn btn-warning">
            <i class="fa fa-money"/> Pre - Liquidar
          </button>&nbsp;
          <button @click="addPayments(true)" class="btn btn-danger">
            <i class="fa fa-money"/> Liquidar
          </button>
        </div>
      </b-col>
    </b-row>

    <!-- <div class="alert alert-warning" v-if="month_settled && !loading && filteredPayments.length">
      <h5>Mes liquidado</h5>
    </div> -->
    <b-row class="form-group">
      <b-col cols="12">
        <div v-for="(requeriments, key) in filteredPayments" :key="key" class="form-group">
          <div class="list-group">
            <b-link class="list-group-item list-group-item-action" v-b-toggle="`${key}`">
              <b>{{external ? requeriments[0].truck.provider.name : (requeriments[0].driver ? `${requeriments[0].driver.name}
              ${requeriments[0].driver.last_name}` : 'Sin conductor') }}</b>
              <br>
              TOTAL SERVICIOS:
              <span>{{ requeriments.reduce((ac, rq) => {return ac + (rq.price ? parseFloat(rq.price) : 0) + (rq.overnight ? parseFloat(rq.overnight) : 0) }, 0) }}</span> {{external ? 'USD' : 'PEN'}}<br>
              DESCUENTO:
              <span>{{ requeriments.reduce((ac, rq) => {return ac + (rq.arr_discount ? parseFloat(rq.arr_discount) : 0) }, 0) }}</span> {{external ? 'USD' : 'PEN'}} <br>
              <b>TOTAL:
              <span>{{ requeriments.reduce((ac, rq) => {return ac + (rq.price ? parseFloat(rq.price) : 0) + (rq.overnight ? parseFloat(rq.overnight) : 0) - (rq.arr_discount ? parseFloat(rq.arr_discount) : 0) }, 0) }}</span> {{external ? 'USD' : 'PEN'}}</b>
            </b-link>
            <b-collapse :id="`${key}`" invisible>
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead>
                  <th>#RQ</th>
                  <th>Cod. liquidación</th>
                  <th>Placa</th>
                  <th>Empresa de transporte</th>
                  <th>Conductor</th>
                  <th>Fecha</th>
                  <th>Servicio</th>
                  <th>Cliente</th>
                  <th>Dirección</th>
                  <th>Zona</th>
                  <th>Contenedor</th>
                  <th>Tamaño</th>
                  <th>Depósito de retiro</th>
                  <th>Depósito de devolución (impo) o entrega Full (expo)</th>
                  <th>Resguardo</th>
                  <th>Estado</th>
                  <th v-if="external">Descuento arrumaje</th>
                  <th>Pernocte</th>
                  <th>Tarifa</th>
                  <th>Moneda</th>
                  <th>Km reconocido</th>
                  <th>Galonaje reconocido</th>
                  </thead>
                  <tbody>
                  <tr v-for="(requeriment, k) in requeriments" :key="k"
                      :class="requeriment.status_logs.some(stl => stl.status.code == constants.PERNOCTAR) && !external ? 'overnight' : ''">
                    <td>
                      {{requeriment.id}} 
                      <i :title="`${requeriment.sell_off ? 'Liquidado' : 'Pre-Liquidado'}`" class="fa fa-money" :style="`color: ${requeriment.sell_off ? 'red': 'orange'};`" /> 
                    </td>
                    <td>{{requeriment.payment_code}}</td>
                    <td>{{requeriment.truck.plate}}</td>
                    <td>{{requeriment.truck.provider.name}}</td>
                    <td>{{requeriment.driver ? `${requeriment.driver.name} ${requeriment.driver.last_name}` : '' }}</td>
                    <td>{{(requeriment.service.service_type.code === constants.PORTEO ? requeriment.appointments[0].schedule : requeriment.date) | formatDateTime}}</td>
                    <td>{{requeriment.service.service_type.name}}</td>
                    <td>{{requeriment.service.company ? requeriment.service.company.name : ''}}</td>
                    <td>{{(requeriment.address && requeriment.address.place) ? `${requeriment.address.alias}
                      ${requeriment.address.place.name}` : '--'}}
                    </td>
                    <td>
                      {{(requeriment.address && requeriment.address.place && requeriment.address.place.zone) ?
                      requeriment.address.place.zone.name : '--'}}
                    </td>
                    <td>{{requeriment.service.service_type.code === constants.PORTEO ?
                      requeriment.appointments.map(ap => ap.container ? ap.container.number : '').join(', ') :
                      requeriment.container_number}}
                    </td>
                    <td>{{requeriment.container_size ? requeriment.container_size.name : ''}}</td>
                    <td>{{requeriment.deposit_pick ? requeriment.deposit_pick.name : ''}}</td>
                    <td>{{requeriment.deposit ? requeriment.deposit.name : ''}}</td>
                    <td>{{requeriment.guard ? (requeriment.custody ? requeriment.custody.name : 'Si, custodia no indicada') : 'No'}}</td>
                    <td>{{requeriment.status ? requeriment.status.name : ''}}</td>
                    <td v-if="external">
                      {{requeriment.arr_discount}}
                      <!-- <input type="number" class="form-control" v-model="requeriment.arr_discount" :disabled="true" /> -->
                    </td>
                    <td>
                        <span v-if="requeriment.status_logs.some(stl => stl.status.code == constants.PERNOCTAR)">
                          <input type="number" class="form-control" v-model="requeriment.overnight"
                                 :disabled="requeriment.sell_off ? true : false"/>
                          <button class="btn btn-success btn-xs" @click="saveOvernight(requeriment)"
                                  v-if="!requeriment.sell_off">Guardar</button>
                        </span>
                    </td>
                    <td>{{requeriment.price}}</td>
                    <td>{{requeriment.currency ? requeriment.currency.code : '--'}}</td>
                    <td>{{requeriment.gallons}}</td>
                    <td>{{requeriment.kms}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </b-collapse>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import api from '@/helpers/api'
  import moment from 'moment'
  import payments_fields from '@/helpers/json_fields/payments_fields'
  import constants from '@/constants'
  import _ from 'lodash'
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        external: false,
        numPages: 100,
        search: '',
        json_fields: payments_fields,
        filteredPayments: [],
        payments: [],
        grouped_payments: {},
        providers: [],
        provider: null,
        initial_trucks: [],
        trucks: [],
        truck: null,
        start_date: moment().format('YYYY-MM-DD 00:00:00'),
        end_date: moment().format('YYYY-MM-DD 23:59:59'),
        // to: moment().endOf('month').format('YYYY-MM-DD 23:59:59'),
        loading: false,
        constants,
        arr_discount: 20,
        arr_discount_third: 32,
        arr_discount_rented: 20,
        EnabledProvider: false,
        EnabledDiscountProvider: true
      }
    },
    computed: {
      ...mapGetters(
        {'user': 'user/user'}
      )
      // filteredPayments(){
      //   return this.payments.filter(payments => {
      //     let condition = true
      //     if(this.search){
      //       let text = this.search.toLowerCase()
      //       condition = payments.truck.plate.toLowerCase().includes(text) ||
      //                   payments.truck.provider.name.toLowerCase().includes(text) ||
      //                   `${payments.driver.name} ${payments.driver.last_name}`.toLowerCase().includes(text)
      //     }
      //     return condition
      //   })
      // }
    },
    mounted() {

      if (this.user.role.code !== constants.PROVEEDOR) {
        api.get('/providers').then(response => {
          this.providers = response.providers.filter(p => !p.owner)
        })
        this.EnabledProvider = true
        this.EnabledDiscountProvider = false
      }

      if (this.user.role.code === constants.PROVEEDOR) {
        api.get('/provider/' + this.user.provider_id)
          .then(response => {
            this.provider = response.provider
          })
        this.external = true;
        this.EnabledProvider = false
        this.EnabledDiscountProvider = true
      }


      api.get('/get_all_trucks').then(response => {
        this.initial_trucks = response.trucks
        this.trucks = response.trucks
      })
    },
    methods: {
      reset() {
        (this.external) ? this.arr_discount = 20 : this.arr_discount = 32;
        this.filteredPayments = []
        this.provider = null
      },
      setProvider(obj) {

        this.provider = obj ? obj : null
        if (obj) {
          //this.getTrucksByProvider()
          this.trucks = this.initial_trucks.filter(t => t.provider_id === this.provider.id)
        } else {
          this.trucks = this.initial_trucks
          this.truck = null
        }
      },
      setTruck(obj) {
        this.truck = obj ? obj : null
      },
      saveOvernight(rq) {
        api.put(`/requeriments/${rq.id}`, {overnight: rq.overnight}).then(response => {
          this.$toastr.success('Pernocte registrado', "Pernocte", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        })
      },
      addPayments(sell_off) {
        
        let payments = []
        let flag = false

        if (sell_off && confirm('Una vez liquidado no podrá realizar modificaciones, ¿Seguro desea liquidar mes?')) {
          flag = true
        } else if(!sell_off){
          flag = true
        }

        if(flag){
          this.filteredPayments.map(fp => {
            
            fp.map(rq => {
              payments.push({
                id: rq.id,
                payment_code: rq.payment_code,
                price: rq.price,
                currency_id: rq.currency_id,
                overnight: rq.overnight,
                arr_discount: rq.arr_discount,
                gallons: rq.gallons,
                payment_id: rq.payment_id,
                sell_off: rq.sell_off,
                kms: rq.kms
              })
            })
          })

          api.post('/add-payments', {payments, sell_off}).then(response => {
            
            this.$toastr.success(sell_off ? `Servicios liquidados exitosamente. Código de liquidación: ${response.payment_code}` : 'Servicios pre-liquidados', "Liquidación", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          })
        }
      },
      send() {

        let trucks_ids = this.trucks.map(t => t.id)
        if (!this.external) {
          trucks_ids = this.initial_trucks.filter(truck => truck.provider.owner).map(t => t.id)

        } else {
          trucks_ids = this.initial_trucks.filter(truck => !truck.provider.owner).map(t => t.id)
          if (this.provider) {
            trucks_ids = this.initial_trucks.filter(truck => truck.provider_id === this.provider.id).map(t => t.id)
          }
        }

        let data = {
          external: this.external,
          arr_discount_third: this.arr_discount_third,
          arr_discount_rented: this.arr_discount_rented,
          provider_id: this.provider ? this.provider.id : null,
          truck_ids: !this.truck ? trucks_ids : [this.truck.id],
          from: moment(this.start_date).format('YYYY-MM-DD 00:00:00'),
          to: moment(this.end_date).format('YYYY-MM-DD 23:59:59')
        }

        this.loading = true
        this.filteredPayments = []
        api.post('/payments', data).then(response => {
          this.loading = false
          this.payments = response.requeriments

          if (this.user.role.code === constants.PROVEEDOR) {
            this.EnabledDiscountProvider = true
          }

          if (this.external) {
            // this.grouped_payments = _.mapValues(_.groupBy(this.payments, 'truck.provider_id'), clist => clist.map(payments => _.omit(payments, 'truck.provider_id')))
            this.grouped_payments = _.groupBy(this.payments, 'truck.provider.name')
          } else {
            // this.grouped_payments = _.mapValues(_.groupBy(this.payments, 'driver_id'), clist => clist.map(payments => _.omit(payments, 'driver_id')))
            this.grouped_payments = _.groupBy(this.payments, 'driver_id')
          }

          this.filteredPayments = Object.values(this.grouped_payments)
        })
      }
    }
  }
</script>

<style scoped>
  .overnight {
    background-color: #e6d349 !important;
  }
</style>
